/*
 * Klick auf eine Countdown-Pill im Kategorie-Hero scrollt weiter nach unten.
 *
 * Das Ziel kommt aus dem Block-Setting "Ziel beim Klick auf die Pill"
 * (data-promo-scroll). Erlaubt sind drei Formen:
 *   ""                    -> die Section direkt unter dem Hero
 *   "main-collection"     -> Section-Kennung aus der Template-JSON
 *   "#id" / ".klasse"     -> ein CSS-Selektor, unveraendert verwendet
 *
 * Warum die Section-KENNUNG und nicht die DOM-ID: Sections aus einer
 * JSON-Vorlage heissen im DOM "shopify-section-template--<themeid>__<kennung>".
 * Die Zahl darin wechselt bei jedem Publish-Swap, eine fest eingetragene
 * DOM-ID waere danach tot. Stabil ist nur der Teil hinter dem Doppel-Unterstrich.
 *
 * Der Name der globalen Marke traegt bewusst einen Unterstrich-Praefix: Jede
 * DOM-id legt im Browser eine gleichnamige window-Eigenschaft an, und ein
 * Schutz, der auf eine id trifft, laesst das Skript stumm abbrechen (siehe
 * assets/moonou-promo-gift.js, Vorfall vom 13.09.2026).
 */
(function () {
  'use strict';

  if (window.__moonouPromoScroll) return;
  window.__moonouPromoScroll = true;

  var SELEKTOR = '[data-promo-scroll]';

  /* Die Section, in der die Pill steckt — von ihr aus suchen wir den Nachbarn. */
  function heroSection(pill) {
    var el = pill;
    while (el && el !== document.body) {
      if (el.id && el.id.indexOf('shopify-section-') === 0) return el;
      el = el.parentElement;
    }
    return null;
  }

  function zielFinden(pill) {
    var wert = (pill.getAttribute('data-promo-scroll') || '').trim();

    if (wert && /^[#.[]/.test(wert)) {
      try {
        var direkt = document.querySelector(wert);
        if (direkt) return direkt;
      } catch (e) {
        /* Ungueltiger Selektor im Setting: nicht die Seite mitreissen. */
        console.warn('[promo-scroll] Ungueltiger Selektor im Block-Setting:', wert, e);
      }
    } else if (wert) {
      /* Section-Kennung: zuerst die Vorlagen-Form, dann die direkte Form. */
      var überKennung =
        document.querySelector('[id$="__' + (window.CSS && CSS.escape ? CSS.escape(wert) : wert) + '"]') ||
        document.getElementById('shopify-section-' + wert);
      if (überKennung) return überKennung;
      console.warn('[promo-scroll] Section "' + wert + '" nicht gefunden, nehme die Section darunter.');
    }

    /* Rueckfall und Standardfall: die Section direkt unter dem Hero. */
    var hero = heroSection(pill);
    return hero ? hero.nextElementSibling : null;
  }

  function kopfhoehe() {
    var wert = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
    var zahl = parseFloat(wert);
    return isFinite(zahl) ? zahl : 0;
  }

  function scrollen(pill) {
    var ziel = zielFinden(pill);
    if (!ziel) return;

    var sanft = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var y = ziel.getBoundingClientRect().top + window.pageYOffset - kopfhoehe();

    window.scrollTo({ top: Math.max(0, Math.round(y)), behavior: sanft ? 'smooth' : 'auto' });
  }

  /* Delegation statt fester Bindung: die Pill wird vom A/B-Laeufer und vom
     Theme-Editor neu gezeichnet, eine einmal gesetzte Bindung waere danach tot. */
  document.addEventListener('click', function (ereignis) {
    var pill = ereignis.target.closest && ereignis.target.closest(SELEKTOR);
    if (!pill) return;
    /* Einen echten Link innerhalb der Pill nicht uebersteuern. */
    if (ereignis.target.closest('a[href], button')) return;
    ereignis.preventDefault();
    scrollen(pill);
  });

  document.addEventListener('keydown', function (ereignis) {
    if (ereignis.key !== 'Enter' && ereignis.key !== ' ' && ereignis.key !== 'Spacebar') return;
    var pill = ereignis.target.closest && ereignis.target.closest(SELEKTOR);
    if (!pill) return;
    ereignis.preventDefault();
    scrollen(pill);
  });
})();
